var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('slide-verify',{attrs:{"slider-text":_vm.text},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"refresh":_vm.onRefresh}}),_c('div',[_vm._v(_vm._s(_vm.msg))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }